import { render, staticRenderFns } from "./ChooseAction.vue?vue&type=template&id=a3684c5e&scoped=true"
import script from "./ChooseAction.vue?vue&type=script&lang=js"
export * from "./ChooseAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3684c5e",
  null
  
)

export default component.exports